//
// DEV environment variables
// APP_CLIENT_ID: Identifies this client app to the API
// APP_BASE_GATE: User authenticating must have this base gate
//
/*
export let Config = {
  APP_VERSION: '1.0.26',
  API_ROOT_CORE: 'http://localhost:5080/',
  API_ROOT_INSTRUCTORS: 'http://localhost:5080/api/v1/tse-instructors/',
  API_ROOT_INSTRUCTORS_PUBLIC: 'http://localhost:5080/api/v1/tse-instructors/public/',
  API_ROOT_RAPID: 'http://localhost:5080/api/v1/odot-rapid/',
  ACCESS_TOKEN: '',
  APP_CLIENT_ID: 'JWkjJJq0WcChzO1',
  APP_BASE_GATE: 'tse-instructors',
  APP_NAME: 'odot-instructor-certification',
  PLATFORM_WIDTH: 0,
  USER: {},
  USER_APPS: []
};
*/

//
// PROD environment variables
//
export let Config = {
  APP_VERSION: '1.0.26',
  API_ROOT_CORE: 'https://api.triwou.org/',
  API_ROOT_INSTRUCTORS: 'https://api.triwou.org/api/v1/tse-instructors/',
  API_ROOT_INSTRUCTORS_PUBLIC: 'https://api.triwou.org/api/v1/tse-instructors/public/',
  API_ROOT_RAPID: 'https://api.triwou.org/api/v1/odot-rapid/',
  ACCESS_TOKEN: '',
  APP_CLIENT_ID: 'JWkjJJq0WcChzO1',
  APP_BASE_GATE: 'tse-instructors',
  APP_NAME: 'odot-instructor-certification',
  PLATFORM_WIDTH: 0,
  USER: {},
  USER_APPS: []
}


// WEBPACK FOOTER //
// ./src/providers/config/config.ts